import { StaticImageData } from 'next/image'

import facebookLogo from '@/static/logos/logo_facebook.svg'
import instagramLogo from '@/static/logos/logo_instagram.svg'
import xLogo from '@/static/logos/logo_x.svg'
import youtubeLogo from '@/static/logos/logo_youtube.svg'

const logos = {
  facebook: facebookLogo,
  instagram: instagramLogo,
  x: xLogo,
  youtube: youtubeLogo,
}

export const getSocialLogo = (name: string): StaticImageData | null => {
  return logos[name as keyof typeof logos] ?? null
}
